import { Injectable } from '@angular/core';
import { SortBy } from '../../shared/enums/sort-by.enum';

@Injectable()
export class StoreService {
  public sortBy = SortBy.POPULAR;
  public categoryId = null;
}
